import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SwitchComponent } from '../../../components/switch/switch.component';
import { randomString } from '../../../lib/random-string';
import { PICFLOW_ANALYTICS } from '../../../picflow-analytics';

@Component({
  selector: 'app-simple-switcher',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './simple-switcher.component.html',
  styleUrl: './simple-switcher.component.scss',
  imports: [FormsModule, SwitchComponent],
})
export class SimpleSwitcherComponent {
  private analytics = inject(PICFLOW_ANALYTICS);
  @Input() value: boolean;
  @Input() name: string;
  @Input() location: string;
  @Input() disabled: boolean;
  @Input() reportingTrueValue: string;
  @Input() reportingFalseValue: string;
  @Output() onSwitch = new EventEmitter<boolean>();
  id = randomString(12);

  switch(value: boolean) {
    this.onSwitch.emit(value);
    this.analytics.track('switcher', false, {
      name: this.name,
      location: this.location,
      value: value ? this.reportingTrueValue : this.reportingFalseValue,
    });
  }
}
